function ExternalLinkIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <g>
        <path
          d="M11.3077 9.03597V12.759C11.3077 13.0882 11.1769 13.4038 10.9442 13.6366C10.7115 13.8693 10.3958 14.0001 10.0667 14.0001H3.24103C2.91189 14.0001 2.59623 13.8693 2.36349 13.6366C2.13075 13.4038 2 13.0882 2 12.759V5.93341C2 5.60427 2.13075 5.28861 2.36349 5.05587C2.59623 4.82313 2.91189 4.69238 3.24103 4.69238H6.9641"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.61533 3H12.9999V7.23077"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.23062 9.76923L12.9999 3"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
export default ExternalLinkIcon;
